import { useState, useEffect } from 'react'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus, numberWithCommas } from '../../../../utils'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { updatecashNonCashApi, addcashNonCashApi } from '../apiService';
import moment from 'moment';
import { regexConstants } from '../../../../constants/regEx';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { PageLoader } from '../../../../shared_elements';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { formatBytes } from '../../../../utils/fileUpload';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const CashTxnCRU = ({ txnCRU, modeType,fileUpload, getResponseBack, onToggleModal, securitydata, onOpenAttachments,getSortingWiseData,sortInfo, sdcData }) => {
    const dispatch=useDispatch()
    const { storageDetails } = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(txnCRU?.data || {});
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [cleared, setCleared] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const { leaseBasicDetails } = useSelector((state) => state.leases);

    useEffect(() => {
        if (!sdcData?.base_currency) {
            setData((prev) => ({
                ...prev,
                base_amount: null
            }));
        }
    }, [sdcData?.base_currency]);

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])
    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
        
    };

    const onFieldChange = (keyParam, value) => {
        setData({ ...data, [keyParam]: value });

    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }


    const onAddEditSecurityDeposit = () => {
        let validationInputs = {};
        validationInputs = {
            reference_number: data?.reference_number?.trim() ? "" : "Please enter Reference Number",
            contractual_amount: data?.contractual_amount ? "" : "Please enter Contractual Amount",
            transaction_date: data?.transaction_date ? "" : "Please select Transaction Date ",
            validity_end_date: data?.validity_end_date ? "" : "Please select Validity End Date",
            validity_start_date: data?.validity_start_date ? "" : "Please select Validity Start Date "
        };
        const transactionDate = moment(data?.transaction_date);
        if(data.transaction_date && !transactionDate.isValid()) {
            validationInputs.transaction_date = "Please enter valid Transaction Date"
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, data);
            payload = {
                ...data,
                base_amount: sdcData?.base_currency ? data?.base_amount : null
            };
            if (data?.id) {
                globalPutService(updatecashNonCashApi({ ...params, slug: securitydata?.slug, txnSlug: data?.slug }), payload)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            if (attachments?.length) {
                                fileUpload(data?.slug,"nonTxn",'updated')
                            }
                            if(sortInfo[securitydata?.slug]?.sort){
                                getSortingWiseData(sortInfo[securitydata?.slug],securitydata?.slug)
                            }
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Cash Txn`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Cash Txn`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addcashNonCashApi({ ...params, slug: securitydata?.slug }), payload).then((response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,"nonTxn",'created')
                        }
                        if (sortInfo[securitydata?.slug]?.sort) {
                            getSortingWiseData(sortInfo[securitydata?.slug], securitydata?.slug)
                        }
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Cash Txn`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Cash Txn`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `Security Deposit ${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Cash Txn`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Security Deposit ${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Cash Txn`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                maxWidth="md"
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add Cash Txn" : modeType === "edit" ? "Edit Cash Txn" : "View Cash Txn"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="reference_number"
                                label="Reference Number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.reference_number || false}
                                helperText={error?.reference_number || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.reference_number || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 100 ? onFieldChange("reference_number", value.trimStart()) : e.preventDefault() : null
                                }}
                                onFocus={() => onRestErrorKey("reference_number")}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Transaction  Date"
                                    minDate={moment(leaseBasicDetails?.start_date)}
                                    // minDate={moment().subtract(25, 'years')}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.transaction_date ? moment(data?.transaction_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("transaction_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("transaction_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.transaction_date || false,
                                            helperText: error.transaction_date || '',
                                            onFocus: () => {error.transaction_date && onRestErrorKey("transaction_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("transaction_date", null); setCleared(true); onRestErrorKey("transaction_date") }
                                        },
                                    }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="contractual_amount"
                                label="Contractual Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.contractual_amount || false}
                                helperText={error?.contractual_amount || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.contractual_amount !== '' && data?.contractual_amount !== null && data?.contractual_amount !== undefined ? numberWithCommas(data?.contractual_amount) : (data?.contractual_amount || "")}
                                onFocus={() => onRestErrorKey("contractual_amount")}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("contractual_amount", "");
                                        return;
                                    }
                                    if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("contractual_amount", val);
                                    }
                                }}
                            />
                        </Grid>
                        {sdcData?.base_currency && 
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="base_amount"
                                label="Base Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.base_amount !== '' && data?.base_amount !== null && data?.base_amount !== undefined ? numberWithCommas(data?.base_amount) : (data?.base_amount || "")}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("base_amount", null);
                                        return;
                                    }
                                    if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("base_amount", val);
                                    }
                                }}
                            />
                        </Grid>}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity Start Date"
                                    minDate={moment().subtract(25, 'years')}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.validity_start_date ? moment(data?.validity_start_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                        onFieldChange("validity_start_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("validity_start_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_start_date || false,
                                            helperText: error.validity_start_date || '',

                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("validity_start_date", null); setCleared(true); onRestErrorKey("validity_start_date") }
                                        },
                                    }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity End Date"
                                    minDate={data?.validity_start_date ? moment(data.validity_start_date) : null}
                                    value={data?.validity_end_date ? moment(data?.validity_end_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                        onFieldChange("validity_end_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("validity_end_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_end_date || false,
                                            helperText: error.validity_end_date || '',

                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("validity_end_date", null); setCleared(true); onRestErrorKey("validity_end_date") }
                                        },
                                    }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Description' value={data?.description || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    rows={3}
                                    id="description"
                                    label="Description"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    value={data?.description || ""}
                                    fullWidth
                                    multiline
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("description", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, description: "" }));
                                    }}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ? <Button onClick={() => { onOpenAttachments(1); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({txnCRU?.data?.attachments?.length})Attachment(s)</Button> : null}
                           <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                           </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditSecurityDeposit() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default CashTxnCRU